import React from 'react';
import { FadeIn } from './FadeIn';
export function Proof() {
  return <section className="py-16 px-4" data-id="element-144">
      <div className="max-w-4xl mx-auto" data-id="element-145">
        <FadeIn data-id="element-146">
          <div className="bg-gradient-to-br from-amber-500/10 to-transparent border-l-4 border-amber-500 p-8 md:p-12 rounded-r-2xl" data-id="element-147">
            <p className="font-serif text-2xl md:text-3xl text-white leading-relaxed italic" data-id="element-148">
              "Most women report a{' '}
              <span className="text-amber-400 font-bold not-italic" data-id="element-149">
                40% reduction
              </span>{' '}
              in 'wake-up anxiety' on the very first night, and a{' '}
              <span className="text-amber-400 font-bold not-italic" data-id="element-150">
                total cessation
              </span>{' '}
              of the '3 AM Panic' within 7 days of balancing their evening
              cortisol levels."
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}